/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * VORGABE DES BETREIBERS (14.09.2026), Abschnitt „Auf welchen Karten":
 * 
 *   Datensatz   Zufall <-> Bestimmt   Feldauswahl   Datensatzauswahl
 * 
 *   ZUFALL          — EIN Datensatz, je Aufruf ein anderer. Er bleibt
 *                     stehen, solange die Karte offen ist.
 *   ZUFALL_WECHSEL  — EIN Datensatz, und im Takt von `rotationSeconds`
 *                     wird neu gewuerfelt (Betreiber 14.09.2026:
 *                     „Bei Datensatz bitte noch Zufall mit Wechsel
 *                     hinzufuegen … nur so ist es sinnvoll").
 *   BESTIMMT        — genau der gewaehlte Datensatz (`datensatzId`).
 *               `datensatzFeldId` sagt, nach welchem Feld die
 *               Datensaetze zur Auswahl aufgelistet werden; ohne Angabe
 *               nach dem Feld der Rolle „Ueberschrift".
 * 
 * OHNE ANGABE bleibt alles wie bisher — ALLE Datensaetze, und „Wechsel
 * alle" entscheidet, ob sie im Takt wechseln oder untereinander stehen.
 * Damit aendert sich keine bestehende Datenbank.
 * @export
 */
export const DatabaseBannerDatensatzWahl = {
    Zufall: 'ZUFALL',
    ZufallWechsel: 'ZUFALL_WECHSEL',
    Bestimmt: 'BESTIMMT'
} as const;
export type DatabaseBannerDatensatzWahl = typeof DatabaseBannerDatensatzWahl[keyof typeof DatabaseBannerDatensatzWahl];


export function DatabaseBannerDatensatzWahlFromJSON(json: any): DatabaseBannerDatensatzWahl {
    return DatabaseBannerDatensatzWahlFromJSONTyped(json, false);
}

export function DatabaseBannerDatensatzWahlFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBannerDatensatzWahl {
    return json as DatabaseBannerDatensatzWahl;
}

export function DatabaseBannerDatensatzWahlToJSON(value?: DatabaseBannerDatensatzWahl | null): any {
    return value as any;
}

